import { cn } from '@repo/ui/lib/cn';
import { Link, useRouterState } from '@tanstack/react-router';
import { Calendar, Gift, Heart, Home, User } from 'lucide-react';

import { LogoText } from '@/components/logo-text';

interface NavItem {
  label: string;
  icon: React.ElementType;
  to: string;
  tourId: string;
}

const navItems: NavItem[] = [
  { label: 'Home', icon: Home, to: '/home', tourId: 'home' },
  {
    label: 'Minha Lista',
    icon: Heart,
    to: '/wishlist/me',
    tourId: 'my-wishlist',
  },
  {
    label: 'Ocasiões',
    icon: Calendar,
    to: '/occasions/me',
    tourId: 'occasions',
  },
  {
    label: 'Lista Parceiro',
    icon: Gift,
    to: '/wishlist/partner',
    tourId: 'partner-wishlist',
  },
  { label: 'Conta', icon: User, to: '/account', tourId: 'account' },
];

export function SidebarNav() {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;

  return (
    <aside className="bg-background border-border/40 fixed top-0 left-0 z-40 hidden h-screen w-64 flex-col border-r md:flex">
      <div className="flex h-16 items-center border-b px-6">
        <Link to="/home">
          <LogoText className="text-2xl" />
        </Link>
      </div>

      <nav className="flex-1 space-y-1 p-4">
        {navItems.map((item) => {
          const isActive = currentPath.startsWith(item.to);
          const Icon = item.icon;

          return (
            <Link
              key={item.to}
              to={item.to}
              data-tour={item.tourId}
              className={cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground',
              )}
            >
              <Icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
